import React, { useState, useEffect } from 'react';
import './login.css';
import LogoHeyHo from '../../assets/images/logo-heyho.png';
import LogoHeyHoAzul from '../../assets/images/heyhoLogoAzul.png';
import LogoHeyHo2 from '../../assets/images/logo-heyho-branco.svg';
import LogoProc from '../../assets/images/processor.svg';
import App from '../../App';
import { authProvider } from './../../services/authProvider';

const Login: React.FC = () => {

    const Login = async () => {
        sessionStorage.setItem("autenticated", 'true')
        await authProvider.LoginMSSO();
    }

    return (
        <>
            <div className="mainLogin">
                {/* <div className="logolc"> */}
                {/* <img src={LogoHeyHo} /> */}
                {/* </div> */}

                <div className="center">
                    <div className="logoHeyhoMobile">
                        <img src={LogoHeyHoAzul} />
                    </div>
                    <div className="title">
                        <h2>Controle preciso e sistemático de todos os processos em formato digital</h2>
                    </div>
                    <div className="buttons">
                        <button id="82220dca-e27c-4434-be67-a0c5fede2cb8" onClick={() => Login()}> Conectar </button>
                    </div>
                </div>
                <div className="logoHeyho">
                    <img src={LogoHeyHo2} />
                </div>
            </div>
        </>
    );
}

export default Login;